import script from "./DomainPrompt.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainPrompt.vue?vue&type=script&setup=true&lang=js"

import "./DomainPrompt.vue?vue&type=style&index=0&id=0399f506&lang=postcss&scope=true"

const __exports__ = script;

export default __exports__